"use client";

import { c as _c } from "react/compiler-runtime";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
export interface AIChatSuggestedPrompt {
  prompt: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
interface AIChatSuggestedPromptsProps {
  prompts: AIChatSuggestedPrompt[];
  onSelect: (prompt: string) => void;
  className?: string;
}
export function AIChatSuggestedPrompts(t0) {
  const $ = _c(10);
  const {
    prompts,
    onSelect,
    className
  } = t0;
  if (prompts.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex w-full flex-col gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onSelect || $[3] !== prompts) {
    let t3;
    if ($[5] !== onSelect) {
      t3 = t4 => {
        const {
          prompt,
          icon: Icon
        } = t4;
        return <Button variant="secondary" key={prompt} type="button" icon={<Icon aria-hidden="true" />} onClick={() => onSelect(prompt)} className="w-full justify-start text-left">{prompt}</Button>;
      };
      $[5] = onSelect;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = prompts.map(t3);
    $[2] = onSelect;
    $[3] = prompts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}